import { AIValidationStatuses, ChipModel, ColorAliases, GridMenuOption } from '@mds/common';
import { MdsIcon } from '@mds/icons';

export const validationRequiredTag: ChipModel = {
  icon: MdsIcon.VALIDATED,
  label: 'Needs Validation',
  removable: false,
  chipCustomBackgroundColor: ColorAliases.WARNING_CONTAINER,
  iconColor: [ColorAliases.WARNING]
};

export const validatedTag: ChipModel = {
  icon: MdsIcon.VALIDATED,
  label: 'Validated',
  removable: false,
  chipCustomBackgroundColor: ColorAliases.SUCCESS_CONTAINER,
  iconColor: [ColorAliases.SUCCESS]
};

export const rejectedTag: ChipModel = {
  icon: MdsIcon.ERROR_2,
  label: 'Invalidated',
  removable: false,
  chipCustomBackgroundColor: ColorAliases.ERROR_CONTAINER,
  iconColor: [ColorAliases.ERROR]
};

export const notApplicableTag: ChipModel = {
  icon: MdsIcon.VALIDATED,
  label: 'N/A',
  removable: false,
  chipCustomBackgroundColor: ColorAliases.INVERSE_CONTENT,
  iconColor: [ColorAliases.TERTIARY_CONTAINER_HOVER]
};

export const CommonMenuData = {
  disabled: false,
  iconHeight: 20,
  iconWidth: 20,
  iconColor: [ColorAliases.TERTIARY],
  label: 'Validated'
};

export const menuOptions: GridMenuOption[] = [
  {
    ...CommonMenuData,
    iconKey: MdsIcon.SUCCESS,
    label: 'Validated',
    value: AIValidationStatuses.VALIDATED
  },
  {
    ...CommonMenuData,
    iconKey: MdsIcon.QUESTION_MARK,
    label: 'Pending',
    value: AIValidationStatuses.PENDING
  },
  {
    ...CommonMenuData,
    iconKey: MdsIcon.CANCELLED,
    label: 'Invalidated',
    value: AIValidationStatuses.REJECTED
  }
];
